jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customised')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });

  // image change on color swatch

  var $ = window.jQuery_T4NT || window.jQuery;
  if (!$) return;

  function getProductWrapper($el) {
    var $parent = $el.parent();

    while ($parent.length && !$parent.is("body")) {
      if (
        $parent.find(".sr4-product-colors").length &&
        $parent.find(".sr4-card-image-slider .sr4-product-img").length
      ) {
        return $parent;
      }

      $parent = $parent.parent();
    }

    return $(document);
  }

  function filterSliderByAlt($colorItem) {
    var selectedAlt = $colorItem.attr("data-alt");

    // Condition 2: agar data-alt empty/null ho to kuch bhi na ho
    if (!selectedAlt || selectedAlt === "null" || selectedAlt === "undefined") {
      return;
    }

    var $wrapper = getProductWrapper($colorItem);
    var $carousel = $wrapper.find(".sr4-card-image-slider.flickitysr4-enabled").first();

    if (!$carousel.length) return;
    if (typeof $carousel.flickitysr4 !== "function") return;

    // Save original all product images one time
    if (!$carousel.data("original-product-imgs")) {
      $carousel.data("original-product-imgs", $carousel.find(".sr4-product-img").toArray());
    }

    var allImages = $carousel.data("original-product-imgs") || [];

    var matchedImages = allImages.filter(function (img) {
      return $(img).attr("data-alt") === selectedAlt;
    });

    // Condition 2: agar koi image match na ho to kuch bhi na ho
    if (!matchedImages.length) {
      return;
    }

    try {
      var currentImages = $carousel.find(".sr4-product-img").toArray();

      if (currentImages.length) {
        $carousel.flickitysr4("remove", currentImages);
      }

      $carousel.flickitysr4("append", matchedImages);

      $(matchedImages).each(function () {
        $(this)
          .show()
          .removeAttr("aria-hidden")
          .removeClass("is-selected");
      });

      setTimeout(function () {
        $carousel.flickitysr4("reloadCells");
        $carousel.flickitysr4("resize");
        $carousel.flickitysr4("select", 0, false, true);
      }, 100);
    } catch (err) {
      console.log("Filter slider error:", err);
    }
  }

  function filterSizesByAlt($colorItem) {
    var selectedAlt = $colorItem.attr("data-alt");

    // Agar data-alt null/empty/unmatched ho to kuch na karo
    if (!selectedAlt || selectedAlt === "null" || selectedAlt === "undefined") {
      return;
    }

    var $wrapper = getProductWrapper($colorItem);
    var $sizes = $wrapper.find("[data-size-item]");

    if (!$sizes.length) return;

    var $matchedSizes = $sizes.filter(function () {
      return $(this).attr("data-size-alt") === selectedAlt;
    });

    // Agar selected color ka koi size match nahi mila to kuch bhi na karo
    if (!$matchedSizes.length) {
      return;
    }

    $sizes.hide();
    $matchedSizes.show();
  }

  $(document).on("click", ".sr4-pr-color__item", function () {
    var $this = $(this);

    // selected class manage
    $this
      .closest(".sr4-product-colors")
      .find(".sr4-pr-color__item")
      .removeClass("is-swatch--selected");

    $this.addClass("is-swatch--selected");

    filterSliderByAlt($this);
    filterSizesByAlt($this);
  });

  // Condition 1: page load pe first color item selected ho
  setTimeout(function () {
    $(".sr4-product-colors").each(function () {
      var $colorsWrap = $(this);

      var $firstColor = $colorsWrap
        .find(".sr4-pr-color__item[data-alt]")
        .filter(function () {
          var alt = $(this).attr("data-alt");
          return alt && alt !== "null" && alt !== "undefined";
        })
        .first();

      if (!$firstColor.length) return;

      $colorsWrap
        .find(".sr4-pr-color__item")
        .removeClass("is-swatch--selected");

      $firstColor.addClass("is-swatch--selected");

      filterSliderByAlt($firstColor);
      filterSizesByAlt($firstColor);
    });
  }, 500);
});